import { render, staticRenderFns } from "./NoDataReceived.vue?vue&type=template&id=fce1157e&scoped=true&"
import script from "./NoDataReceived.vue?vue&type=script&lang=js&"
export * from "./NoDataReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce1157e",
  null
  
)

/* custom blocks */
import block0 from "./NoDataReceived.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports